import React, { Component } from 'react'
import { connect } from 'react-redux'
import CategoryUI from '../components/category/CategoryUI'
import CategorySettingForm from '../components/category/CategorySettingForm';
import { jsonResponseHandler } from '../utils/FetchHelper'
import { initCategories } from '../actions/category'
import LoadingBox from "../components/common/LoadingBox";
import LoadErrorBox from "../components/common/LoadErrorBox";
import * as InitStatus from '../constants/common/InitializationStatus';
import CategoryMovePopupLayer from "../components/category/layer/CategoryMovePopupLayer";
import CategoryInfoLayer from "../components/category/layer/CategoryInfoLayer";
import {addPrefix} from "../utils/UriUtil";
import {TISTORY, DAUMBLOG} from "../constants/Service";

@connect(state => ({
  openMoveLayer: (typeof state.popup !== 'undefined' && state.popup.isMovingCategoryOpened),
  infoEditCategory: state.category.infoEditCategory
}), dispatch => ({
  initCategories: (data) => {
    dispatch(initCategories(data))
  },
  dispatch
}))
class CategoryApp extends Component {

  constructor(props) {
    super(props);

    this.state = {
      initialized : InitStatus.INIT_READY,
      optionList : null,
      selected : null,
    };

    this.init = this.init.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  init() {
    const { initCategories, dispatch } = this.props;

    this.setState({
      initialized: InitStatus.INIT_DOING,
    });

    fetch(addPrefix("/manage/category.json"), {
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        initCategories(data);
        this.setState({
          initialized : InitStatus.INIT_SUCCESS,
          optionList : data.settingOptionList,
          selected : data.settingSelected,
        })
      })
      .catch(e => {
        console.error(e);
        this.setState({
          initialized : InitStatus.INIT_FAIL,
        })
      })
  }

  render() {
    const { openMoveLayer, infoEditCategory } = this.props;
    const {initialized, optionList, selected} = this.state;

    return (
      <div className="inner_article">
        <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
        { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
        { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={this.init}/>}

        { (initialized === InitStatus.INIT_SUCCESS && window.Config.service === TISTORY ) && <div className="blog_category">
          <h3 className="tit_cont">카테고리 관리</h3>
          <CategoryUI />
          <h3 className="tit_cont">카테고리 설정</h3>
          <CategorySettingForm  optionList={optionList} selected={selected}/>
        </div>
        }
        { (initialized === InitStatus.INIT_SUCCESS && window.Config.service === DAUMBLOG ) && <div className="blog_category">
          <h3 className="tit_cont">카테고리 관리</h3>
          <CategoryUI />
        </div>
        }
        {openMoveLayer && <CategoryMovePopupLayer />}
        {infoEditCategory && <CategoryInfoLayer />}
      </div>
    );
  }

}

export default CategoryApp;



